import { motion } from "framer-motion";

const mask = "radial-gradient(ellipse at center, #000 35%, transparent 78%)";

const all = [
  { src: "/blueprint-car.jpg", cls: "left-[-22%] top-[-2%] w-[46%] max-w-[760px]", rot: 0, dur: 26, alt: "" },
  { src: "/blueprint-window.jpg", cls: "right-[-12%] top-[22%] w-[44%] max-w-[700px]", rot: 6, dur: 30, alt: "" },
  { src: "/blueprint-car.jpg", cls: "right-[-24%] top-[62%] w-[44%] max-w-[720px] -scale-x-100", rot: 0, dur: 28, alt: "" },
  { src: "/blueprint-window.jpg", cls: "left-[-14%] top-[78%] w-[36%] max-w-[560px] -scale-x-100", rot: -5, dur: 32, alt: "" },
];

export const FloatingPatterns = ({ count = 4 }) => (
  <div className="pointer-events-none absolute inset-0 hidden overflow-hidden sm:block" aria-hidden data-testid="floating-patterns">
    {all.slice(0, count).map((a, i) => (
      <motion.img
        key={a.cls}
        src={a.src}
        alt={a.alt}
        className={`absolute ${a.cls} select-none opacity-[0.65]`}
        style={{ mixBlendMode: "screen", maskImage: mask, WebkitMaskImage: mask, rotate: a.rot }}
        animate={{ y: [0, -26, 0], rotate: [a.rot, a.rot + 1.5, a.rot] }}
        transition={{ duration: a.dur, repeat: Infinity, ease: "easeInOut", delay: i * 2 }}
      />
    ))}
  </div>
);
